import React from 'react';

const SvgFolderDistributedNSEnforced = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M13.472 5.87h4.54a3.613 3.613 0 013.6 3.61v.59h-1.5v-.59a2.101 2.101 0 00-2.1-2.11h-4.85a.767.767 0 01-.53-.22l-2.11-2.1h-4.53a2.108 2.108 0 00-2.11 2.1v9.7a2.108 2.108 0 002.11 2.1h5.225v1.5H5.992a3.613 3.613 0 01-3.61-3.6v-9.7a3.606 3.606 0 013.61-3.6h4.84a.71.71 0 01.53.22l2.11 2.1z"
        fill="currentColor"
      />
      <path
        d="M15.202 9.557a4.915 4.915 0 00-.66-.357v-.46a.757.757 0 00-.57-.73 8.564 8.564 0 00-3.952 0 .768.768 0 00-.57.73v.46a4.926 4.926 0 00-2.9 4.84v.04a1.663 1.663 0 00-1.28 1.5c0 1.769 2.993 2.268 5.438 2.381l-1.292-1.288a.945.945 0 01-.214-.35c-1.433-.193-2.181-.512-2.392-.723a.89.89 0 01.45-.13c.025 0 .05-.003.075-.005a.756.756 0 01.075-.005.745.745 0 00.64-.74v-.68a3.614 3.614 0 011.4-3.12v.22a.75.75 0 101.5 0V9.36a6.865 6.865 0 012.09 0v.71h1.65l.512-.513z"
        fill="currentColor"
      />
      <path
        d="M10.294 14.496a12.818 12.818 0 01-1.214-.186c-.48-.08-.29.56.18.81.09.05.18.097.273.14l.761-.764z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line spellcheck/spell-checker
        d="M17.646 10.204l1.35 1.348h1.92a.694.694 0 01.684.577v2.03l1.35 1.357a.69.69 0 01.08.875l-.08.096-1.332 1.365v1.907a.708.708 0 01-.579.692h-2.043l-1.35 1.347a.702.702 0 01-.877.088l-.097-.088-1.368-1.338h-1.911a.702.702 0 01-.693-.578v-2.03l-1.35-1.348a.708.708 0 01-.088-.875l.088-.096 1.35-1.356v-1.925a.699.699 0 01.702-.7h1.902l1.35-1.348a.702.702 0 01.992 0zm-1.32 7.936c.142 0 .28-.045.395-.128l3.259-2.684.076-.086.004-.005a.663.663 0 000-.853.673.673 0 00-.943-.093l-2.773 2.247-1.167-1.165-.101-.08-.011-.007a.673.673 0 00-.826 1.05l1.592 1.597.092.073.007.006a.673.673 0 00.396.128z"
        fill="currentColor"
      />
    </svg>
  );
});
export default SvgFolderDistributedNSEnforced;
SvgFolderDistributedNSEnforced.iconName = 'folder-distributed-ns-enforced';
SvgFolderDistributedNSEnforced.displayName = 'SvgFolderDistributedNSEnforced';
